import React, { useState, useCallback } from "react";
import styled from "styled-components";
import { injectIntl } from "react-intl";

const Wrapper = styled.div`
  width: 100%;
  min-height: 400px;
  border-radius: 5px;
  border: 1px dashed ${(p) => p.theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 2rem;
  font-weight: bold;
  color: ${(p) => p.theme.altColors.danger};

  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 4px,
    ${(p) => p.theme.backgrounds.danger} 2px,
    ${(p) => p.theme.backgrounds.danger} 6px
  );
`;

const Icon = styled.i`
  font-size: 52px;
  background-color: white;
  border-radius: 50%;
  height: 75px;
  width: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(p) => p.theme.backgrounds.danger};
  color: ${(p) => p.theme.altColors.danger};
`;

const SmallIcon = styled(Icon)`
  font-size: 22px;
  height: 45px;
  width: 45px;

  cursor: pointer;

  &:hover {
    background: ${(p) => p.theme.backgrounds.danger};
  }
  margin-right: 5px;
`;

export default injectIntl((props) => {
  const {
    parentId,
    remove,
    pageType,
    componentsConfig,
    AddComponentPanel,
    id,
    parentType,
    rootId,
    children = [],
    add,
  } = props;

  const [expand, setExpand] = useState(false);

  const thisAdd = useCallback((props) => {
    add(props);
    setExpand(false);
  }, []);

  if (pageType === "viewTemplate") {
    return (
      <>
        <Wrapper>
          <Icon className="fad fa-cubes" />
          {props.intl.formatMessage({ id: "Content" })}
          <div className="d-flex">
            <SmallIcon
              data-id={id}
              data-parentid={rootId}
              className="fad fa-trash"
              onClick={remove}
            />
            <SmallIcon
              data-id={id}
              data-parentid={rootId}
              className={`${expand ? "fas fa-times" : "fas fa-plus"}`}
              onClick={() => setExpand(!expand)}
            />
          </div>
        </Wrapper>
        {expand && (
          <AddComponentPanel
            onClick={() => setExpand(false)}
            pageType={pageType}
            nodeType="Root"
            type="sibling"
            hoverIcon="fal fa-square"
            hoverLabel="Add section"
            componentsConfig={componentsConfig}
            id={id}
            add={thisAdd}
          />
        )}
      </>
    );
  } else {
    if (children.length !== 0) {
      return children;
    }

    return (
      <AddComponentPanel
        pageType={pageType}
        nodeType={props.parentType}
        type="child"
        hoverIcon="fal fa-square"
        hoverLabel="Add section"
        componentsConfig={componentsConfig}
        id={rootId}
        add={props.add}
      />
    );
  }
});
